import { isEmpty } from 'lodash';
import { useQuery } from '../useQuery';
import { getCancelReasons } from '@dispatch/shared/services';

export const useGetCancelReasons = (
  { tenantId }: { tenantId: string },
  enabled = true
) => {
  const { data, refetch, status } = useQuery(
    ['cancel-reasons', tenantId],
    () => getCancelReasons(tenantId),
    {
      enabled: enabled && !isEmpty(tenantId),
    }
  );

  return {
    cancelReasons: data,
    fetchCancelReasons: refetch,
    cancelReasonStatus: status,
  };
};

export default useGetCancelReasons;
